import { FC } from "react";

import DashboardLayout from "layouts/DashboardLayout";

import { FrameContainer, FullSectionLoader } from "uikit";

import useAdminPayPage from "./useAdminPayPage";
import { Container } from "./styles";

interface Props {
  className?: string;
}

const AdminPayPage: FC<Props> = () => {
  const { frameId, isLoading } = useAdminPayPage();

  return (
    <DashboardLayout showTitle={false} showBreadcrumbs={false}>
      <Container>
        {isLoading && <FullSectionLoader />}
        <FrameContainer id={frameId} />
      </Container>
    </DashboardLayout>
  );
};

export default AdminPayPage;
